import { ref, computed, onMounted } from 'vue'
import deepClone from 'foundation/js/deepClone'
import VueEasyLightbox from 'vue-easy-lightbox'
import Glide from "@glidejs/glide"

let glide

export default {
    name: "ImageGallery",
    components: { VueEasyLightbox },
    props: {
        imgs: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: "Product"
        }
    },
    setup(props) {

        const imgs = computed(() => props.imgs.imgs)
        const imgRatio = computed(() => props.type === "Product" ? "5-4" : "2-3")
        const visibleRef = ref(false)
        let indexRef = ref(0) // default 0
        const imgsRef = ref(imgs.value)
        const activeImg = ref(deepClone(imgs.value[0]))

        const mobileSlider = ref(window.innerWidth > 475 ? false : true)

        const onShow = () => {
            visibleRef.value = true
        }

        const showMultiple = () => {
            imgsRef.value = imgsRef.value

            let isActiveImg = (element) => element.src === activeImg.value.src
            let activeIndex = imgsRef.value.findIndex(isActiveImg)

            indexRef.value = activeIndex

            onShow()
        }

        const onHide = () => (visibleRef.value = false)

        const updateActiveImg = function (e) {
            activeImg.value.src = e.target.src
            activeImg.value.alt = e.target.alt
        }

        onMounted(() => {
            glide = new Glide('#imageGalleryGlideId', {
                perView: 1.15,
                gap: 15,
                peek: {
                    after: 0,
                    before: 0
                }
            })
            
            if (imgs.value.length > 1) {
                glide.mount()
            }

            window.addEventListener("resize", () => {
                if (window.innerWidth > 475) {
                    mobileSlider.value = false

                } else if (window.innerWidth <= 475) {
                    mobileSlider.value = true

                    if (imgs.value.length > 1) {
                        glide.mount()
                    }

                }
            })

        })

        return {
            visibleRef,
            indexRef,
            imgsRef,
            showMultiple,
            onHide,
            imgs,
            imgRatio,
            activeImg,
            mobileSlider,
            updateActiveImg
        }

    }
}